// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".toast__container[data-v-58466f79]{position:fixed;top:58px;right:40px;z-index:1050;display:flex;flex-direction:column-reverse}@media only screen and (max-width: 768px){.toast__container[data-v-58466f79]{right:20px;left:20px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
